module.exports = __webpack_public_path__ + "static/img/14000720.ff4c9ec0.png";